<!-- TEMPLATE -->
<template>
    <div :class='ordersListClass'>
      <div class='row'>
        <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
          <dean-section-title content='true'>
            <span slot='title'>
              <span class='avenir-heavy'>Orders</span>
            </span>
          </dean-section-title>
          <dean-table
                  :data='ordersData'
                  :columns='columns'
                  :hover="true"
                  @column-click='columnClick'
                  @cell-click="cellClick"
          >
            <span slot="services" slot-scope="services">
              <dean-icon v-for="serviceIcon in services.value.content"
                         :key="serviceIcon.id"
                         className="serviceIcon"
                         :glyph="serviceIcon"
                         width="25"
                         height="25"
                         title="Service">
              </dean-icon>
            </span>
            <span slot="status" slot-scope="status">
              <dean-icon v-for="statusIcon in status.value.content"
                         :key="statusIcon.id"
                         className="serviceIcon"
                         :glyph="statusIcon"
                         width="25"
                         height="25"
                         title="Service">
              </dean-icon>
            </span>
          </dean-table>
          <dean-pagination
                  :current-page='ordersMetaData.pageNumber'
                  :total-items='ordersMetaData.totalResults'
                  :items-per-page='ordersMetaData.itemsPerPage'
                  :select-items-per-page='selectItemsPerPage'
                  :visible-pages='ordersMetaData.visiblePages'
                  @page-changed='paginationChanged'
                  @items-per-page='itemsPerPageChanged'
          >
          </dean-pagination>
        </div>
      </div>
    </div>
</template>

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import axios from 'axios';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import sideMenuPartnerMixin from '@/mixins/sideMenuPartnerMixin';
  import {mixins} from 'vue-class-component';
  import { formatPrice } from '@/mixins/formatPrice';
  import {servicesStringToIcons, statusStringToIcons} from '@/mixins/stringToIcons';

  import {
    // SVG
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon
  } from '@deanone/dean-components';

  import wonIcon from '@/assets/svg/won.svg';
  import statusIcon from '@/assets/svg/status.svg';
  import { getDutchDateFormat } from '@/mixins/dateWrapper';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
    },
  })
  export default class List extends mixins(deanTableMixin, sideMenuPartnerMixin) {
    public showSomething: boolean = false;
    public plusIcon: object = plusIcon;
    public data: object[] = [];

    // COMPUTED
    get ordersListClass() {
      let value = 'address-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get ordersMetaData() {
      return this.pageMeta;
    }

    get ordersData() {
      return this.data;
    }

    public meta: object = {};

    get columns(): any {
      return {
          orderNumber: {
          content: 'Ordernummer',
          align: 'left',
          sort: true,
          dql: 'orderNumber',
        },
        partnerName: {
          content: 'Partnernaam',
          align: 'left',
          sort: true,
          dql: 'partnerName',
        },
        customerName: {
          content: 'Klantnaam',
          align: 'left',
          sort: true,
          dql: 'customerName',
        },
        monthlyAmount: {
          content: 'Maandbedrag',
          align: 'left',
          sort: true,
          dql: 'monthlyAmount',
        },
        createdDate: {
          content: 'Aangemaakt op',
          align: 'left',
          sort: true,
          dql: 'createdDate',
        },
        plannedDate: {
          content: 'Plandatum',
          align: 'left',
          sort: true,
          dql: 'plannedDate',
        },
        invoicedDate: {
          content: 'Facturatiedatum',
          align: 'left',
          sort: true,
          dql: 'invoicedDate',
        },
        services: {
          content: 'Diensten',
          type: 'slot',
          slot: 'services',
          align: 'center',
          sort: false,
          dql: 'services',
        },
        status: {
          content: 'Status',
          type: 'slot',
          slot: 'status',
          align: 'center',
          sort: false,
          dql: 'status',
        },
      };
    }

    public tableName(): string {
      return 'partner-orders';
    }

    public cellClick(target: { cell: object, row: { transactionId: string }, column: string }) {
      this.$router.push({
        name: 'orders.orderlines',
        params: { transactionId: target.row.transactionId },
      });
    }

    // METHODS
    public loadList(data: any) {
      this.$store.dispatch('setLoadOverlay', true);

      const url = '/-/trade/api/partner.orders.list';

      const requestData = {
        sort: data.sort,
        pid: this.$route.params.pid,
        meta: {
          startIndex: this.startIndex,
          numberOfItems: data.itemsPerPage,
        },
      };

      axios.post(url, requestData)
        .then((response) => {
            this.data = response.data.data.map((order: any) => {
                return {
                    id: order.id,
                    orderNumber: order.orderNumber,
                    transactionId: order.transactionId,
                    partnerName: order.partnerName,
                    customerName: order.customerName,
                    monthlyAmount: formatPrice(order.monthlyAmount),
                    createdDate: getDutchDateFormat(order.createdDate),
                    plannedDate: getDutchDateFormat(order.plannedDate) || 'Geen',
                    invoicedDate: getDutchDateFormat(order.invoicedDate) || 'Geen',
                    services: servicesStringToIcons(order.services),
                    status: statusStringToIcons(order.status),
                };
            });

          this.updateMeta(response.data.meta);
        }).then(
        // Resolve promise response/error
        (response) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
        (error) => {
          this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public created() {
      this.setDefaultSort('orderNumber');
      this.loadList(this.pageMeta);
      this.buildSideMenuPartner();
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
  @import '~@deanone/dean-components/src/scss/vars';
</style>